import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useBookDemo } from "../hooks/useBookDemo";

const CTABanner = () => {
  const { openBookDemo } = useBookDemo();
  return (
    <section className="bg-white" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      {/* Horizontal divider line */}
      <div className="max-w-full">
        <div className="border-t border-gray-200" />
      </div>

      {/* CTA Content */}
      <div className="py-16 md:py-24 lg:py-28">
        <div className="max-w-[1300px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12 max-w-[1100px] mx-auto">
            {/* Left: Heading */}
            <h2 
              className="text-[#1a1a2e] leading-tight text-center md:text-left"
              style={{ fontSize: "clamp(28px, 4vw, 48px)", fontWeight: 800 }}
            >
              Bring AI learning to your institution or organisation.
            </h2>

            {/* Right: Two button cards */}
            <div className="flex items-center gap-4 sm:gap-5 flex-shrink-0">
              {/* Purple "Book a demo" button — hover: white bg, purple text, purple arrow circle */}
              <a href="#demo" onClick={openBookDemo} className="relative group cursor-pointer" data-testid="cta-book-demo">
                <div className="w-[160px] h-[110px] sm:w-[220px] sm:h-[140px] bg-[#8B5CF6] group-hover:bg-white border-[3px] border-gray-900 rounded-3xl flex items-end pb-6 sm:pb-8 pl-5 sm:pl-7 transition-all duration-500 ease-in-out">
                  <span className="text-white group-hover:text-[#8B5CF6] text-[16px] sm:text-[20px] font-semibold transition-all duration-500 ease-in-out">Book a demo</span>
                </div>
                <div className="absolute top-3 right-3 sm:top-5 sm:right-5 w-11 h-10 sm:w-14 sm:h-12 bg-white group-hover:bg-[#8B5CF6] rounded-full flex items-center justify-center transition-all duration-500 ease-in-out">
                  <ArrowUpRight className="w-5 h-5 sm:w-6 sm:h-6 text-[#1a1a2e] group-hover:text-white transition-all duration-500 ease-in-out" strokeWidth={2.5} />
                </div>
              </a>

              {/* White "Explore ai labs" button — hover: black bg, white text, white arrow circle */}
              <a href="https://app.elevante.ai/login" target="_blank" rel="noopener noreferrer" className="relative group cursor-pointer" data-testid="cta-explore-labs">
                <div className="w-[160px] h-[110px] sm:w-[220px] sm:h-[140px] bg-white group-hover:bg-[#1a1a2e] border-[3px] border-gray-900 rounded-3xl flex items-end pb-6 sm:pb-8 pl-5 sm:pl-7 transition-all duration-500 ease-in-out">
                  <span className="text-[#1a1a2e] group-hover:text-white text-[16px] sm:text-[20px] font-semibold transition-all duration-500 ease-in-out">Explore ai labs</span>
                </div>
                <div className="absolute top-3 right-3 sm:top-5 sm:right-5 w-11 h-10 sm:w-14 sm:h-12 bg-[#8B5CF6] group-hover:bg-white rounded-full flex items-center justify-center transition-all duration-500 ease-in-out">
                  <ArrowUpRight className="w-5 h-5 sm:w-6 sm:h-6 text-white group-hover:text-[#1a1a2e] transition-all duration-500 ease-in-out" strokeWidth={2.5} />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
